import uiRouter from '@uirouter/angularjs';
import angular from 'angular';
import { CustomersControllerModule } from './controllers/CustomersController';
import { CustomersIndividualsView } from './individuals/individuals';

export const CustomersView = angular
  .module('acme.view.application.customers', [
    uiRouter,
    'ui.bootstrap',
    CustomersControllerModule,
    CustomersIndividualsView,
    'acme.common.directive.detailList',
  ])

  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const customers = {
      name: 'application.customers',
      url: '/customers',
      abstract: true,
      views: {
        'subview-main': {
          controller: 'CustomersController',
          templateUrl: 'views/application/views/customers/customers.tpl.html',
        },
      },
      data: {
        pageTitle: 'Customers',
        permissions: ['CUSTOMERS_VIEW'],
      },
    };

    $stateProvider.state(customers);
  }).name;
